import axios from 'axios';
import { AppConfig, JWT } from '../config';

const GetList = async (dataQuery) => {
	const data = {
		data: dataQuery
	};
	try {
		const ret = await axios.post(AppConfig.API_SERVER_PATH + '/common/', data, JWT());
		return ret.data;
	} catch (error) {
		console.warn('[CommonAction.GetList] API error:', error?.response?.data || error?.message);
		return { status: 'fail', data: [] };
	}
};

const GetRecord = async (data) => {
	try {
		const ret = await axios.post(AppConfig.API_SERVER_PATH + '/q', data, JWT());
		return ret.data;
	} catch (error) {
		console.warn('[CommonAction.GetRecord] API error:', error?.response?.data || error?.message);
		return { status: 'fail', data: [] };
	}
};

const GetCountAction = async (dataQuery) => {
	const data = {
		data: dataQuery
	};
	try {
		const ret = await axios.post(AppConfig.API_SERVER_PATH + '/common/', data, JWT());
		return ret.data;
	} catch (error) {
		console.warn('[CommonAction.GetCountAction] API error:', error?.response?.data || error?.message);
		return { status: 'fail', data: [] };
	}
};

const AcqCountLastHours = async (dataQuery) => {
	const data = {
		data: dataQuery
	};
	try {
		const ret = await axios.post(AppConfig.API_SERVER_PATH + '/common/acqCountLastHours', data, JWT());
		return ret.data;
	} catch (error) {
		console.warn('[CommonAction.AcqCountLastHours] API error:', error?.response?.data || error?.message);
		return { status: 'fail', data: [] };
	}
};

const DailyModality = async (dataQuery) => {
	const data = {
		data: dataQuery
	};
	try {
		const ret = await axios.post(AppConfig.API_SERVER_PATH + '/common/dailyModality', data, JWT());
		return ret.data;
	} catch (error) {
		console.warn('[CommonAction.DailyModality] API error:', error?.response?.data || error?.message);
		return { status: 'fail', data: [] };
	}
};

const ServerTime = async () => {
	try {
		const ret = await axios.get(AppConfig.API_SERVER_PATH + '/common/serverTime', JWT());
		return ret.data;
	} catch (error) {
		console.warn('[CommonAction.ServerTime] API error:', error?.response?.data || error?.message);
		return { status: 'fail', data: null };
	}
};

export const CommonAction = {
	GetList,
	GetCountAction,
	AcqCountLastHours,
	DailyModality,
	GetRecord,
	ServerTime
};
